import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_APPLICATION_WITHDRAWAL_DROPDOWN} from '../../constants/apiUrls';
import {
  NON_NATIONAL_APPLICATION_WITHDRAWAL_STATUS_DROPDOWN_QUERY_KEY
} from '../../constants/queryKeys';
import {IDropdown} from '../../modules/examRegistration/components/nonNationalExam/OpsAdminForm';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  allStatus?: boolean;
  onSuccess?: (data: IDropdown[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalApplicationWithdrawalStatus = ({
                                                               allStatus = false,
                                                               onSuccess,
                                                               onError,
                                                             }: Input) => {
  const getNonNationalApplicationWithdrawalStatus = async () => {
    const res = await axiosClient.get<IDropdown[]>(
        GET_NON_NATIONAL_APPLICATION_WITHDRAWAL_DROPDOWN(allStatus)
    );
    return res.data;
  };
  return useCustomQuery(
      [NON_NATIONAL_APPLICATION_WITHDRAWAL_STATUS_DROPDOWN_QUERY_KEY],
      getNonNationalApplicationWithdrawalStatus,
      {
        onSuccess,
        onError,
      }
  );
};
